<template>
  <div class="switcher max-lg:flex max-lg:relative">
    <button
      v-click-outside="closeDropdown"
      class="dropdown-toggle uppercase"
      aria-label="cart"
      @click="toggleDropdown"
    >
      <icon-cart class="max-lg:text-primary-1 !text-[24px] !mb-0" />
      <div
        v-if="cartStore.getCartCount && cartStore.getCartCount > 0"
        class="absolute -left-2.5 lg:-left-0.5 top-[25%] text-[14px] lg:text-[16px] w-[20px] h-[20px] rounded-full bg-primary-2 text-white"
      >
        {{ cartStore.getCartCount }}
      </div>
    </button>
    <!-- <transition name="collapse-sm"> -->
    <template v-if="isDesktop">
      <div v-if="isOpen" class="dropdown-menu mt-3">
        <template v-for="(item, index) in list" :key="index">
          <button
            v-if="item.authorize"
            class="menu-item cart-menu-item"
            @click="() => item.action()"
          >
            <component :is="item.icon" class="!block !text-[24px] !mb-0" />
            {{ item.name }}
          </button>
        </template>
      </div>
    </template>
    <BaseBottomSheet v-else v-model:show="isOpen" fitHeight>
      <div class="px-7">
        <template v-for="(item, index) in list" :key="index">
          <button
            v-if="item.authorize"
            class="menu-item cart-menu-item"
            @click="() => item.action()"
          >
            <component :is="item.icon" class="!block !text-[24px] !mb-0" />
            {{ item.name }}
          </button>
        </template>
      </div>
    </BaseBottomSheet>

    <!-- <Auth ref="authRef" /> -->
    <!-- </transition> -->
  </div>
</template>

<script setup lang="ts">
import { computed, onMounted, ref, watch } from "vue";
import { useCartStore } from "./../../stores/cart.store";
import { useRouter } from "vue-router";
import { useCart } from "../../composables/useCart";
import { useCookie, useRuntimeConfig } from "nuxt/app";

const accessToken = useCookie("accessToken").value;
const { isLoggedIn, logout, userProfile } = useAuth();
const { fetchCart } = useCart();
const cartStore = useCartStore();
const router = useRouter();
const localePath = useLocalePath();
const { t } = useI18n();

interface CartDropdownItems {
  name: string;
  icon: string;
  action: () => void;
  authorize: boolean;
}

const config = useRuntimeConfig() as unknown as RuntimeConfiguration;
const loginSignupEnabled = config.public.features.loginSignup;
const isOpen = ref(false);
const authRef = ref<any>(null);
const isDesktop = ref(false);

const toggleDropdown = () => {
  isOpen.value = !isOpen.value;
};
const closeDropdown = () => {
  isOpen.value = false;
};
const handleResize = () => {
  isDesktop.value = window.innerWidth >= 1024;
};

onMounted(() => {
  handleResize();
});

watch(
  [accessToken, userProfile],
  () => {
    if (!accessToken || userProfile.value?.id)
      fetchCart(userProfile.value?.cart?.uuid);
  },
  { deep: true, immediate: true }
);

const emit = defineEmits(["open-login"]);
const list = computed<CartDropdownItems[]>(() => [
  {
    name: `${t("paymentCart.shoppingCart")} (${cartStore.getCartCount})`,
    icon: "icon-cart",
    action: () => {
      router.push(localePath({ name: "cart" }));
    },
    authorize: true,
  },
  // {
  //   name: t("paymentCart.yourOrders"),
  //   icon: "icon-order",
  //   action: () => {
  //     console.log("clicked on orders");
  //   },
  //   authorize: isLoggedIn.value,
  // },
  {
    name: t("paymentCart.loginSignup"),
    icon: "icon-user",
    action: () => {
      emit("open-login", true);
    },
    authorize: !isLoggedIn.value && !!loginSignupEnabled,
  },
  {
    name: t("paymentCart.signOut") + " " + userProfile.value?.first_name,
    icon: "icon-user",
    action: () => {
      logout();
    },
    authorize: isLoggedIn.value,
  },
]);
</script>

<style scoped>
.cart-menu-item {
  @apply !flex items-center gap-2 justify-start text-mobile-heading-6 lg:text-heading-6  
  max-lg:border-b max-lg:border-gray-2 max-lg:py-5 max-lg:w-full text-gray-1;
  &:last-child {
    @apply max-lg:border-none max-lg:pb-2.5;
  }
}
.temp-supplier-four-home .main-menu .switcher .dropdown-toggle svg {
  @apply !text-white;
}
</style>
